// pt-BR é a fonte canônica — pt-BR.ts exporta o pack completo.
import common from './common'
import auth from './auth'
import nav from './nav'
import enums from './enums'
import errors from './errors'
import overview from './overview'
import map from './map'
import devices from './devices'
import alerts from './alerts'
import account from './account'
import groups from './groups'
import history from './history'
import reports from './reports'
import orders from './orders'
import geofences from './geofences'
import shared_link from './shared_link'
import placeholder from './placeholder'
import activate from './activate'
import phones from './phones'
import sharing from './sharing'
import users from './users'
import search from './search'
import pwa from './pwa'
import paywall from './paywall'
import admin from './admin'
import seller from './seller'

export default {
  admin,
  seller,
  common,
  auth,
  nav,
  enums,
  errors,
  overview,
  map,
  devices,
  alerts,
  account,
  groups,
  history,
  reports,
  orders,
  geofences,
  shared_link,
  placeholder,
  activate,
  phones,
  sharing,
  users,
  search,
  pwa,
  paywall,
}
